import { useFilterOptionsBase, BaseFilterOptionsResponse } from './useFilterOptionsBase';

/**
 * Hook for fetching report filter options.
 * Returns available users, projects, and admin status for the Reports page.
 */
export const useReportFilterOptions = () => {
  const result = useFilterOptionsBase<BaseFilterOptionsResponse>('/reports/filterOptions');

  return {
    availableUsers: result.availableUsers,
    availableProjects: result.availableProjects,
    isAdmin: result.isAdmin,
    loading: result.loading,
    error: result.error,
    refresh: result.refresh,
  };
};
